import { render, staticRenderFns } from "./pot-cargo-create.vue?vue&type=template&id=9c5a831e"
import script from "./pot-cargo-create.vue?vue&type=script&lang=js"
export * from "./pot-cargo-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports